// src/com/trans_plan_launch/TransPlanUploadDict.js
import { TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

const Dict = {
    storeId : {
		id: 'storeId', label: '점포', required: true, toAdd: true, toEdit: true,
    },
    hocha : {
        id: 'hocha', label: '호차',required: true, toAdd: true, toEdit: true,
    },
    /* transTypeName : { // WAVE1, WAVE2, WAVE3 ==> Front에서 점검.
        id: 'transTypeName', label: '배차구분', required: false, toAdd: true, toEdit: true,
    }, */
    transTypeCd: { id: 'transTypeCd', label: '배차구분', required: true, toAdd: true, toEdit: true, },
    vehTypeId : {
        id: 'vehTypeId', label: '차종', required: true, toAdd: true, toEdit: true,
    },
    comId: {
        id: 'comId', label: '운송사', required: true, toAdd: true, toEdit: true,
        check: (value) => /^(19|20)\d\d[01]\d{5}$/.test(value), // 2024030001
    },
    shprReqTime : {
        id: 'shprReqTime', label: '접안시간', required: true, toAdd: true, toEdit: true,
    }, // csv는 date, time으로 나눠서 입력
    dptrReqTime : {
        id: 'dptrReqTime', label: '출발요청시간', required: true, toAdd: true, toEdit: true,
    }, // csv는 date, time으로 나눠서 입력
    arrReqTime : {
        id: 'arrReqTime', label: '도착요청시간', required: true, toAdd: true, toEdit: true,
    }, // csv는 date, time으로 나눠서 입력
    dockno : {
        id: 'dockno', label: 'Dock No.', required: false, toAdd: true, toEdit: true,
    }, // varchar(3)
    addCharge : {
        id: 'addCharge', label: '추가운임', required: false, toAdd: true, toEdit: true,
        check: (value) => value >= 0 && value <= 1000000,
    }, // int(11)
    /* bindText: {
        id: 'bindText', label: '동적', required: false, toAdd: true, toEdit: true,
        // "nnn-nn[/nnn-nn[/nnn-nn...]]" 형식으로 입력.
        check: (value) => /^\d+-\d+(\/\d+-\d+)*$/.test(value),
    }, */
    note : {
        id: 'note', label: '비고', required: false, toAdd: true, toEdit: true,
    }, // varchar(300)
    vehPlates: {
        id: 'vehPlates', label: '차량번호', required: false, toAdd: true, toEdit: true,
    },
    driverName: {
        id: 'driverName', label: '기사명', required: false, toAdd: true, toEdit: true,
    },
    driverMobile: {
        id: 'driverMobile', label: '전화번호', required: false, toAdd: true, toEdit: true,
    },
    zipgiBool : {
        id: 'zipgiBool', label: '집기', required: false, toAdd: true, toEdit: true,
    },
    transFlag: {
        id: 'transFlag', label: '배차Flag', required: false, toAdd: true, toEdit: true,
    }
};

// 점포,호차,배차구분,차종,운송사,접안요청일,접안요청시간,출발요청일,출발요청시간,도착요청일,도착요청시간,Dock NO.,추가운임비,동적,비고,차량번호,기사명,전화번호
export const TransPlanCsvMap = {
    storeId : {
		id: 'storeId', label: '점포', required: true,
        check: (value) => /^\d+$/.test(value),
    },
    hocha : {
        id: 'hocha', label: '호차',required: true,
        check: (value) => /^\d+$/.test(value),
    },
    transTypeName : { // WAVE1, WAVE2, WAVE3 ==> Front에서 점검.
        id: 'transTypeName', label: '배차구분', required: false,
    },
    vehTypeId : {
        id: 'vehTypeId', label: '차종', required: true,
        check: (value) => /^\d+$/.test(value) && /[1-9]/.test(value),
    },
    comId: {
        id: 'comId', label: '운송사', required: true,
        check: (value) => /^(19|20)\d\d[01]\d{5}$/.test(value), // 2024030001
    },
    shprReqDate: {
        id: 'shprReqDate', label: '접안요청일', required: true,
        check: (value) => IsValid.date(value),
    },
    shprReqTime : {
        id: 'shprReqTime', label: '접안요청시간', required: true,
        check: (value) => IsValid.hhColonMm(value),
    }, // csv는 date, time으로 나눠서 입력
    dptrReqDate: {
        id: 'dptrReqDate', label: '출발요청일', required: true,
        check: (value) => IsValid.date(value),
    },
    dptrReqTime : {
        id: 'dptrReqTime', label: '출발요청시간', required: true,
        check: (value) => IsValid.hhColonMm(value),
    }, // csv는 date, time으로 나눠서 입력
    arrReqDate: {
        id: 'arrReqDate', label: '도착요청일', required: true,
        check: (value) => IsValid.date(value),
    },
    arrReqTime : {
        id: 'arrReqTime', label: '도착요청시간', required: true,
        check: (value) => IsValid.hhColonMm(value),
    }, // csv는 date, time으로 나눠서 입력
    dockno : {
        id: 'dockno', label: 'Dock No.', required: false,
    }, // varchar(3)
    addCharge : {
        id: 'addCharge', label: '추가운임', required: false,
        check: (value) => value >= 0 && value <= 1000000,
    }, // int(11)
    bindText: {
        id: 'bindText', label: '동적', required: false,
        // "nnn-nn[/nnn-nn[/nnn-nn...]]" 형식으로 입력.
        check: (value) => IsValid.nullString(value) || /^\d+-\d+(\/\d+-\d+)*$/.test(value),
    },
    note : {
        id: 'note', label: '비고', required: false,
        check: (value) => IsValid.nullString(value) || IsValid.getUtf8BytesLength(value) <= 300,
    }, // varchar(300)
    vehPlates: {
        id: 'vehPlates', label: '차량번호', required: false,
        check: (value) => IsValid.nullString(value) || IsValid.getUtf8BytesLength(value) <= 20,
    }, // 서울34가1234
    driverName: {
        id: 'driverName', label: '기사명', required: false,
        check: (value) => IsValid.nullString(value) || IsValid.getUtf8BytesLength(value) <= 24,
    },
    driverMobile: {
        id: 'driverMobile', label: '전화번호', required: false,
        check: (value) => IsValid.nullString(value) || /^[-0-9]{9,13}$/.test(value),
    },
    zipgiYn : {
        id: 'zipgiYn', label: '집기', required: false,
        check: (value) => IsValid.nullString(value) || value === 'Y' || value === 'N',
    },
};

/**
 * TRANS_PLAN Table에 데이터 일괄 추가/수정위한 업로드.
 * Dictionary for Input and Output
 * Project: NewTOP for cloud
 * CSV Titles: 점포,호차,배차구분,차종,운송사,접안요청일,접안요청시간,출발요청일,출발요청시간,도착요청일,도착요청시간,Dock NO.,추가운임비,동적,비고,차량번호,기사명,전화번호
  * Value Sample: 283,1,WAVE1,83,2018051005,2024-09-03,05:30,2024-09-03,06:00,2024-09-03,07:30,0,0,,냉동 2돌리 ,경기94사4385,이우화,010-4477-1251
 */
export const TransPlanUploadDictionary = {
    tableId: 'TransPlanUploadTable',
    inputMap: Dict,
    errorTitle: {
        Add: '운송요청 업로드 오류',
    },
    tableProps: {
        tableId: 'transPlanTable',
        uniqueKey: 'key',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            // csv data 보여주기.
            { id: 'ok', label: '상태', width: 50, show: true, option:{align: 'center', print:(r,i,v)=>v?'OK':<span style={{color:'red'}}>오류</span>} },
            { id: 'storeId', label: TransPlanCsvMap.storeId.label, width: 70, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'hocha', label: TransPlanCsvMap.hocha.label, width: 60, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            { id: 'transTypeName', label: TransPlanCsvMap.transTypeName.label, width: 60, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'vehTypeId', label: TransPlanCsvMap.vehTypeId.label, width: 60, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'comId', label: TransPlanCsvMap.comId.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'shprReqDate', label: TransPlanCsvMap.shprReqDate.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'shprReqTime', label: TransPlanCsvMap.shprReqTime.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'dptrReqDate', label: TransPlanCsvMap.dptrReqDate.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'dptrReqTime', label: TransPlanCsvMap.dptrReqTime.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'arrReqDate', label: TransPlanCsvMap.arrReqDate.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'arrReqTime', label: TransPlanCsvMap.arrReqTime.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'dockno', label: TransPlanCsvMap.dockno.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'addCharge', label: TransPlanCsvMap.addCharge.label, width: 70, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'bindText', label: TransPlanCsvMap.bindText.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'note', label: TransPlanCsvMap.note.label, width: 120, show: true, option:{align: 'left', type:TableColumnType.TEXT} },
            { id: 'vehPlates', label: TransPlanCsvMap.vehPlates.label, width: 120, show: true, option:{align: 'left', type:TableColumnType.TEXT} },
            { id: 'driverName', label: TransPlanCsvMap.driverName.label, width: 80, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'driverMobile', label: TransPlanCsvMap.driverMobile.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            {
                id: 'zipgiBool', label: TransPlanCsvMap.zipgiYn.label,
                width: 60, show: true,
                option:{
                    align: 'center',
                    print:(r,i,v) => v ? 'Y' : '',
                }
            },
        ],
    },
};

function checkItem(item, waveCodeMap, vehTypeList, storeList, comList, keyMap) {
    const errors = item.errors ? [...item.errors] : [];

    if(keyMap.hasOwnProperty(item.key)) {
        errors.push(`중복된 배차: 점포=${item.storeId}, 호차=${item.hocha}`);
    }

    if(!storeList.includes(item.storeId)) {
        errors.push(`없는 점포: ${item.storeId}`);
    }

    if(!vehTypeList.includes(item.vehTypeId)) {
        errors.push(`없는 차종: ${item.vehTypeId}`);
    }

    if(!comList.includes(item.comId)) {
        errors.push(`없는 운송사: ${item.comId}`);
    }

    if(item.bindText) {
        const binds = item.bindText.split('/').filter((v) => v.length > 0);
        if(binds.length===0) {
            item.bindText = null;
        }
        else if(binds.length < 2) {
            errors.push('동적은 2개 이상이어야 합니다.');
        }
        else {
            if(binds.includes(item.key)) item.bindText = binds.join('/');
            else errors.push('동적에 자체 운송요청이 없습니다.');
        }
    }
    else item.bindText = null;

    for(const id of Object.keys(TransPlanCsvMap)) {
        const label = TransPlanCsvMap[id].label;
        if(IsValid.nullString(item[id])) {
            if(TransPlanCsvMap[id].required && TransPlanCsvMap[id].toAdd) {
                errors.push(`${label} 없음.`);
            }
            item[id] = null;
        }
        else {
            const check = TransPlanCsvMap[id].check;
            if(check) {
                const good = check(item[id]);
                if(!good) {
                    errors.push(`${label} 오류(${item[id]}).`);
                }
            }
        }
    }

    if(!IsValid.nullString(item.transTypeName)) {
        if(!waveCodeMap.hasOwnProperty(item.transTypeName)) {
            errors.push(`배차구분 오류: ${item.transTypeName}`);
        }
    }

    const checkVehicle
    = (IsValid.nullString(item.vehPlates) ? 0 : 1)
    + (IsValid.nullString(item.driverName) ? 0 : 1)
    + (IsValid.nullString(item.driverMobile) ? 0 : 1);
    if(checkVehicle !== 0 && checkVehicle !== 3) {
        errors.push('차량번호, 기사명, 전화번호 모두 입력하거나 모두 입력하지 않아야 합니다.');
    }

    if(errors.length > 0) {
        item.ok = false;
        item.message = errors.join("\n");
    }
    else {
        item.ok = true;
        item.message = 'Ready';
    }
    return item;
}


export function checkTransPlanAndMap(someKey, data, waveCodeMap, vehTypeList, storeList, comList) {
    let countError = 0;
    const keyMap = {};

    const records = data.map((array) => {
        // 점포,호차,배차구분,차종,운송사,접안요청일,접안요청시간,출발요청일,출발요청시간,도착요청일,도착요청시간,Dock NO.,추가운임비,동적,비고,차량번호,기사명,전화번호,집기.
        // 집기는 대부분 없는 듯.
        const storeId = array[0];
        const hocha = array[1];
        const key = `${storeId}-${hocha}`;
        const zipgiYn = IsValid.nullString(array[18]) ? '' : array[18].toUpperCase();

        let item = {
            key: key,
            storeId: storeId,
            hocha: hocha,
            transTypeName: array[2],
            vehTypeId: array[3],
            comId: array[4],
            shprReqDate: array[5],
            shprReqTime: array[6],
            dptrReqDate: array[7],
            dptrReqTime: array[8],
            arrReqDate: array[9],
            arrReqTime: array[10],
            dockno: array[11],
            addCharge: array[12],
            bindText: array[13],
            note: array[14],
            vehPlates: array[15],
            driverName: array[16],
            driverMobile: array[17],
            zipgiBool: zipgiYn==='Y' ? true : zipgiYn==='N' ? false : null,
        }
        item = checkItem(item, waveCodeMap, vehTypeList, storeList, comList, keyMap);
        keyMap[key] = item.ok ? 1 : -1; // 아래 최종 바인드 체크를 위해.
        if(!item.ok) countError++;
        return item;
    });

    const bindMap = {};

    records.forEach((item) => {
        if(item.ok && item.bindText) {
            const binds = item.bindText.split('/');
            for(const bind of binds) {
                if(!keyMap.hasOwnProperty(bind)) {
                    item.ok = false;
                    item.message = '없는 운송요청이 동적목록에 들어있습니다: ' + bind;
                    countError++;
                    break;
                }
            }
            if(item.ok) {
                bindMap[item.bindText] = binds.map((storeHocha) => {
                    const pair = storeHocha.split('-');
                    return {storeId: pair[0], hocha: pair[1], planDate: item.shprReqDate};
                });
            }
        }
    });
    // 한번더.
    records.forEach((item) => {
        if(item.ok && item.bindText) {
            const binds = bindMap[item.bindText];
            for(const bind of binds) {
                if(keyMap[`${bind.storeId}-${bind.hocha}`] !== 1) {
                    item.ok = false;
                    item.message = '동적대상 운송요청에 오류가 있습니다.';
                    delete bindMap[item.bindText];
                    countError++;
                    break;
                }
            }
        }
    });
    return {records, bindMap, countError};
}

export function reformTransPlanToUpload(item, dcCd, waveCodeMap) {
    const obj = {};
    Object.keys(Dict).forEach((key) => {
        if(item.hasOwnProperty(key)) {
            obj[key] = item[key];
        }
    });
    obj.dcCd = dcCd;
    obj.transTypeCd = IsValid.string(item.transTypeName,1,20) ? waveCodeMap[item.transTypeName.toUpperCase()] : null;
    obj.planDate = item.shprReqDate;
    obj.shprReqTime = `${item.shprReqDate} ${item.shprReqTime}:00`;
    obj.dptrReqTime = `${item.dptrReqDate} ${item.dptrReqTime}:00`;
    obj.arrReqTime = `${item.arrReqDate} ${item.arrReqTime}:00`;
    // obj.transFlag = item.vehPlates ? true : false; // 서버에서 판단.
    obj.zipgiBool = item.zipgiBool;
    if(obj.hocha) obj.hocha = parseInt(obj.hocha);
    if(obj.addCharge) obj.addCharge = parseInt(obj.addCharge);
    else obj.addCharge = 0;
    return obj;
}